import { useGetAutoLoanApplicationQuery } from "@lending/hooks/queries/AutoLoanApplication/useGetAutoLoanApplicationQuery";
import { useGetCreditCardApplicationQuery } from "@lending/hooks/queries/CreditCardApplication/useGetCreditCardApplicationQuery";
import { useGetPersonalLoanApplicationQuery } from "@lending/hooks/queries/PersonalLoanApplication/useGetPersonalLoanApplicationQuery";
import { useProductType } from "@lending/hooks/useProductType";

function useMembershipShareApplication() {
  const productType = useProductType();

  const personalLoanQuery = useGetPersonalLoanApplicationQuery({
    enabled: productType === "personal-loan",
  });
  const creditCardQuery = useGetCreditCardApplicationQuery({
    enabled: productType === "credit-card",
  });
  const autoLoanQuery = useGetAutoLoanApplicationQuery({
    enabled: productType === "auto-loan",
  });

  if (productType === "credit-card") {
    return {
      application: creditCardQuery.data,
      isLoading: creditCardQuery.isLoading,
      isRefetching: creditCardQuery.isRefetching,
      isError: creditCardQuery.isError,
    };
  }

  if (productType === "auto-loan") {
    return {
      application: autoLoanQuery.data,
      isLoading: autoLoanQuery.isLoading,
      isRefetching: autoLoanQuery.isRefetching,
      isError: autoLoanQuery.isError,
    };
  }

  return {
    application: personalLoanQuery.data,
    isLoading: personalLoanQuery.isLoading,
    isRefetching: personalLoanQuery.isRefetching,
    isError: personalLoanQuery.isError,
  };
}

export { useMembershipShareApplication };
